import { render, staticRenderFns } from "./CategoryRanking.vue?vue&type=template&id=f99d0a04&scoped=true&"
import script from "./CategoryRanking.vue?vue&type=script&lang=js&"
export * from "./CategoryRanking.vue?vue&type=script&lang=js&"
import style0 from "./CategoryRanking.vue?vue&type=style&index=0&id=f99d0a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d0a04",
  null
  
)

export default component.exports